"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var Text_1 = __importDefault(require("../Text"));
var colors_1 = require("../../style/colors");
var constant_1 = require("../../constant");
var style_1 = require("../../style");
var linkStyle = react_1.css({
    cursor: 'pointer',
});
var Link = function (props) {
    var theme = react_1.useTheme();
    var themeName = theme.name;
    return (react_1.jsx(Text_1.default, __assign({ css: linkStyle, color: themeName === constant_1.DESIGN_SYSTEM
            ? style_1.DesignSystemThemeColor.Primary.DEFAULT
            : colors_1.SixsenseColor.Blue.DEFAULT }, props)));
};
exports.default = Link;
